import { loadPreferences, myPreferences, savePreferences } from '@/appLogic/view/preferences';
import { TableType } from '@/coreDomainsModule/table';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * 列幅をDBに保存する
 */
export class BulkSaveColumnWidthsUseCase {
  /**
   * 列幅の配列を保存する
   * @param tableType - テーブルの種類
   * @param columnWidths - ヘッダーのキーと列幅のオブジェクト
   * @returns 失敗した時はエラーを返す
   */
  public async Execute(tableType: TableType, columnWidths: { [key: string]: number }): Promise<INetworkResult<void, Error>> {
    try {
      // 最新のPreferencesを取得
      await loadPreferences();
      if (!myPreferences || !Object.keys(myPreferences).includes(tableType)) {
        return {
          status: {
            type: 'error',
            error: Error('保存に失敗しました'),
          },
        };
      }
      const preference = simpleCopy(myPreferences[tableType]);
      preference.columnWidths = columnWidths;
      myPreferences[tableType] = preference;
      await savePreferences();
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
